'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../../customer/actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _DispatchWarning = require('../DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _OrderConfirmation = require('./OrderConfirmation');

var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);

var _Opener = require('../Opener');

var _Opener2 = _interopRequireDefault(_Opener);

var _Address = require('./Address');

var _Address2 = _interopRequireDefault(_Address);

var _ContactForm = require('./ContactForm');

var _ContactForm2 = _interopRequireDefault(_ContactForm);

var _UserContactsBase2 = require('./UserContactsBase');

var _UserContactsBase3 = _interopRequireDefault(_UserContactsBase2);

var _Note = require('./Note');

var _Note2 = _interopRequireDefault(_Note);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    return {
        mode: state.customer.contact.mode,
        contact: state.customer.contact,
        contactErrors: state.customer.contactErrors,
        selectedDeliveryId: state.cart.deliveryTypeId
    };
}

var mapDispatchToProps = {
    changeContact: _actions2.default.changeContact,
    validate: _actions2.default.validate
};

var AnonymousUserContacts = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_UserContactsBase) {
    (0, _inherits3.default)(AnonymousUserContacts, _UserContactsBase);

    function AnonymousUserContacts(props) {
        (0, _classCallCheck3.default)(this, AnonymousUserContacts);
        return (0, _possibleConstructorReturn3.default)(this, (AnonymousUserContacts.__proto__ || (0, _getPrototypeOf2.default)(AnonymousUserContacts)).call(this, props, true));
    }

    (0, _createClass3.default)(AnonymousUserContacts, [{
        key: 'cartNote',
        value: function cartNote() {
            if (_utils2.default.skEnvironment()) {
                return _react2.default.createElement(_Note2.default, null);
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                mode = _props.mode,
                contact = _props.contact,
                contactErrors = _props.contactErrors,
                selectedDeliveryId = _props.selectedDeliveryId;
            var defaultCountryId = contact.defaultCountryId;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cart-no-reg-header' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'cart__section-title without_registration' },
                        Resx.App.ContactDetails,
                        ' - ',
                        mode === _ContactForm.FormMode.anonymous ? Resx.App.PurchaseWithoutRegistration : Resx.App.PurchaseAndRegister
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn--small', onClick: this.props.back },
                            Resx.Common.Back
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart__form without_registration' },
                    _react2.default.createElement(_ContactForm2.default, { selectedDeliveryId: selectedDeliveryId, mode: mode, contact: contact,
                        errors: contactErrors,
                        onChange: this.props.changeContact, validate: this.props.validate }),
                    _react2.default.createElement(
                        _Opener2.default,
                        { icon: 'icon--tie', title: Resx.App.IAmCompany,
                            open: contact.companyIsFilledIn,
                            onChange: function onChange(e) {
                                return _this2.changeState('companyIsFilledIn', e.target.checked);
                            } },
                        this.companyInfo()
                    ),
                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
                    _react2.default.createElement(
                        _Opener2.default,
                        { icon: 'icon--plus', title: Resx.App.DifferentDeliveryAddress,
                            open: contact.useCustomDeliveryAddress,
                            onChange: function onChange(e) {
                                return _this2.changeState('useCustomDeliveryAddress', e.target.checked);
                            } },
                        _react2.default.createElement(_Address2.default, { selectedDeliveryId: selectedDeliveryId,
                            value: contact.deliveryAddress || { countryId: defaultCountryId },
                            prefix: 'deliveryAddress.',
                            errors: contactErrors.clientErrors.deliveryAddress || {},
                            onChange: function onChange(e) {
                                return _this2.changeState('deliveryAddress', e.value);
                            } })
                    ),
                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
                    this.cartNote(),
                    _react2.default.createElement('hr', { className: 'hr--no-mr-top' }),
                    _react2.default.createElement(_DispatchWarning2.default, null),
                    _react2.default.createElement(_OrderConfirmation2.default, { canContinue: function canContinue() {
                            return true;
                        } })
                )
            );
        }
    }]);
    return AnonymousUserContacts;
}(_UserContactsBase3.default), _class2.propTypes = {
    contact: _propTypes2.default.object,
    changeContact: _propTypes2.default.func,
    selectedDeliveryId: _propTypes2.default.number,
    back: _propTypes2.default.func
}, _temp)) || _class);
exports.default = AnonymousUserContacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/AnonymousUserContacts.js
// module id = 1031
// module chunks = 0